import axios from "axios";
import React, { useEffect, useState } from "react";
import { Card, Form, FormGroup, Modal, ModalBody, Spinner } from "reactstrap";
import {
  Block,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Col,
  Icon,
  PaginationComponent,
  ProcessTable,
  RSelect,
} from "../../../components/Component";
import { authHeader } from "../../../header";
import Content from "../../../layout/content/Content";
import Head from "../../../layout/head/Head";

import { message } from "antd";
import { useForm } from "react-hook-form";
import { processOptions, statusOptions } from "../options_common";
import { AllowAccess } from "../../../components/BlockAccess";

export const ProcessManagement = () => {
  const [modal, setModal] = useState({
    edit: false,
    add: false,
    view: false,
    addStage: false,
  });
  const [editId, setEditedId] = useState("");
  const [formData, setFormData] = useState({
    processName: "",
    status: "",
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage] = useState(7);
  const [processFlowData, setProcessFlowData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadBtn, setIsLoadBtn] = useState(false);

  const resetForm = () => {
    setFormData({});
  };

  const [manageRole, setManageRole] = useState([]);

  const getManageRole = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/auth/admin/role`, {
        headers: authHeader(),
      });
      const resultData = response.data;
      if (resultData) {
        setManageRole(resultData);
        setIsLoading(false);
      }
      return { formData };
    } catch (error) {
      setIsLoading(false);
    }
  };

  // Getting Process Stage
  const [processStage, setProcessStage] = useState();
  const getAllProcessStages = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/auth/stage?platform=TREASURY`, {
        headers: authHeader(),
      });
      const { data } = await response.data;
      const resultData = data.body;
      const filteredStages = resultData.filter((data) => data.status === "ACTIVE");
      if (resultData) {
        setProcessStage(filteredStages);
        setIsLoading(false);
      }
      return { formData };
    } catch (error) {
      setIsLoading(false);
    }
  };

  const [processStageData, setProcessStageData] = useState({
    role: "",
    stageName: "",
    status: "",
  });

  const [selectedProcessStages, setSelectedProcessStages] = useState();

  const resetStageForm = () => {
    setProcessStageData({
      role: "",
      stageName: "",
      status: "",
    });
    setSelectedProcessStages();
  };

  const addProcessStage = async (obj) => {
    try {
      const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/auth/admin/stage`, obj, {
        headers: authHeader(),
      });
      const formData = await response.data;
      if (formData) {
        getAllProcessStages();
        setModal({ ...modal, addStage: false });
        resetStageForm();
        message.success({
          content: "Process Stage Created Successfully",
          style: {
            marginTop: "20vh",
          },
        });
      }
      return { formData };
    } catch (error) {
      const err = error.response;
      resetStageForm();
      message.success({
        content: err.data.message,
        style: {
          marginTop: "20vh",
        },
      });
    }
  };

  const getAllProcessFlow = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/auth/process-flow?platform=TREASURY`, {
        headers: authHeader(),
      });
      const { data } = await response.data;
      const resultData = data.body;
      if (resultData) {
        setProcessFlowData(resultData);
        setIsLoading(false);
      }
      return { formData };
    } catch (error) {
      setIsLoading(false);
    }
  };

  const createProcess = async (obj, stages) => {
    const data = {
      ...obj,
      stage: stages,
      platform: "TREASURY",
    };
    try {
      setIsLoadBtn(true);
      const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/auth/admin/process-flow`, data, {
        headers: authHeader(),
      });
      const formData = await response.data;
      if (formData) {
        getAllProcessFlow();
        setIsLoadBtn(false);
        setIsLoading(false);
        setModal({ add: false });
        resetForm();
        message.success({
          content: "Process Created Successfully",
          style: {
            marginTop: "20vh",
          },
        });
      }
    } catch (error) {
      const erroMsg = error.response;
      setIsLoadBtn(false);
      setIsLoading(false);
      setModal({ add: false });
      resetForm();
      message.error({
        content: erroMsg.data.message,
        style: {
          marginTop: "20vh",
        },
      });
    }
  };

  const editProcess = async (obj, stages) => {
    const data = {
      ...obj,
      stage: stages,
      platform: "TREASURY",
    };
    try {
      setIsLoadBtn(true);
      const response = await axios.put(`${process.env.REACT_APP_BASE_URL}/auth/admin/process-flow/${editId}`, data, {
        headers: authHeader(),
      });
      const formData = await response.data;
      if (formData) {
        getAllProcessFlow();
        setIsLoadBtn(false);
        setIsLoading(false);
        setModal({ edit: false });
        resetForm();
        message.success({
          content: "Process Updated Successfully",
          style: {
            marginTop: "20vh",
          },
        });
      }
    } catch (error) {
      setIsLoadBtn(false);
      setIsLoading(false);
      const erroMsg = error.response;
      message.error({
        content: erroMsg.data.message,
        style: {
          marginTop: "20vh",
        },
      });
    }
  };

  const onFormCancel = () => {
    setModal({ edit: false, add: false, addProcess: false });
    resetForm();
    resetStageForm();
  };

  const onStageFormSubmit = () => {
    addProcessStage({ ...processStageData, platform: "TREASURY" });
    setModal({ addStage: false, add: true });
  };

  const handleCreateProcess = () => {
    var stages = selectedProcessStages.map((stage) => {
      return {
        action: "ACTION_PENDING",
        platform: "TREASURY",
        stage: stage.value,
      };
    });
    createProcess(formData, stages);
    resetForm();
    setModal({ add: false });
  };

  const onEditSubmit = () => {
    var stages = selectedProcessStages.map((stage) => {
      return {
        action: "ACTION_PENDING",
        platform: "TREASURY",
        stage: stage.value,
      };
    });
    editProcess(formData, stages);
  };

  const onEditClick = (item) => {
    setModal({ edit: true });
    const stageArr = item.stage.map((stg) => stg.stage);
    const stagesToMark = stageArr?.map((stage) => ({
      label: stage?.stageName,
      value: stage?.id,
    }));
    setFormData({
      processName: item.processName,
      status: item.status,
    });
    setSelectedProcessStages(stagesToMark);
    setEditedId(item.id);
  };

  const [details, setDetails] = useState();
  const handleView = (item) => {
    setModal({ view: true });
    setDetails({
      processName: item.processName,
      stage: item.stage,
    });
  };

  const indexOfLastItem = currentPage * itemPerPage;
  const indexOfFirstItem = indexOfLastItem - itemPerPage;
  const currentItems = processFlowData.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const { errors, register, handleSubmit } = useForm();

  useEffect(() => {
    getManageRole();
    getAllProcessFlow();
    getAllProcessStages();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const stageOptions =
    processStage?.map((item) => ({
      label: item.stageName,
      value: item.id,
    })) ?? [];

  const roleOptions =
    manageRole?.map((item) => ({
      label: item.roleName,
      value: item.id,
    })) ?? [];

  return (
    <React.Fragment>
      <Head title="Process Flow Management" />
      <Content>
        <Block size="lg">
          <BlockHead>
            <BlockHeadContent>
              <div className="d-flex justify-content-between align-items-center">
                <BlockTitle tag="h4">Process Flow</BlockTitle>
                <AllowAccess allowedRights={["CREATE_PROCESS_FLOW"]}>
                  <Button color="primary" onClick={() => setModal({ add: true })}>
                    <Icon name="plus" />
                    <span>Create Process Flow</span>
                  </Button>
                </AllowAccess>
              </div>
            </BlockHeadContent>
          </BlockHead>
          <Card className="card-bordered card-preview">
            {isLoading ? (
              <Spinner
                color="primary"
                style={{
                  height: "3rem",
                  width: "3rem",
                  margin: "0 auto",
                }}
              />
            ) : (
              <ProcessTable process={currentItems} modal={modal} handleView={handleView} onEditClick={onEditClick} />
            )}
          </Card>
          <div className="card-inner">
            {processStage && processStage.length > 0 ? (
              <PaginationComponent
                itemPerPage={itemPerPage}
                totalItems={processFlowData.length}
                paginate={paginate}
                currentPage={currentPage}
              />
            ) : (
              <div className="text-center">
                <span className="text-silent">No Process Stage Found</span>
              </div>
            )}
          </div>
        </Block>

        <Modal isOpen={modal.add} toggle={() => setModal({ add: false })} className="modal-dialog-centered" size="lg">
          <ModalBody>
            <a
              href="#cancel"
              onClick={(ev) => {
                ev.preventDefault();
                onFormCancel();
              }}
              className="close"
            >
              <Icon name="cross-sm" />
            </a>
            <div className="p-2">
              <h5 className="title">Add Process</h5>
              <div className="mt-4">
                <Form className="row gy-4" onSubmit={handleSubmit(handleCreateProcess)}>
                  <Col md="5">
                    <FormGroup>
                      <label className="form-label">Process Name</label>
                      <RSelect
                        options={processOptions}
                        onChange={(e) => setFormData({ ...formData, processName: e.value })}
                      />
                    </FormGroup>
                  </Col>
                  <Col md="5">
                    <FormGroup>
                      <label className="form-label">Stage</label>
                      <RSelect
                        isMulti
                        closeMenuOnSelect={false}
                        options={stageOptions}
                        placeholder="Please select Stages"
                        onChange={(e) => setSelectedProcessStages(e)}
                      />
                    </FormGroup>
                  </Col>
                  <Col md="2">
                    <FormGroup>
                      <label className="form-label">Create Stage</label>
                      <Button color="primary" onClick={() => setModal({ ...modal, addStage: true })}>
                        <Icon name="plus" />
                      </Button>
                    </FormGroup>
                  </Col>
                  <Col md="12">
                    <FormGroup>
                      <label className="form-label">Status</label>
                      <RSelect
                        options={statusOptions}
                        placeholder="Select Status"
                        onChange={(e) => setFormData({ ...formData, status: e.value })}
                      />
                    </FormGroup>
                  </Col>

                  <Col size="12">
                    <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                      <li>
                        {isLoadBtn ? (
                          <Button color="primary" disabled>
                            <Spinner size="sm">Loading...</Spinner>
                            <span> Loading</span>
                          </Button>
                        ) : (
                          <Button color="primary" size="md" type="submit">
                            Submit
                          </Button>
                        )}
                      </li>
                      <li>
                        <Button
                          onClick={(ev) => {
                            ev.preventDefault();
                            onFormCancel();
                          }}
                          className="link link-light"
                        >
                          Cancel
                        </Button>
                      </li>
                    </ul>
                  </Col>
                </Form>
              </div>
            </div>
          </ModalBody>
        </Modal>
        <Modal isOpen={modal.edit} toggle={() => setModal({ edit: false })} className="modal-dialog-centered" size="lg">
          <ModalBody>
            <a
              href="#cancel"
              onClick={(ev) => {
                ev.preventDefault();
                onFormCancel();
              }}
              className="close"
            >
              <Icon name="cross-sm" />
            </a>
            <div className="p-2">
              <h5 className="title">Edit Process</h5>
              <div className="mt-4">
                <Form className="row gy-4" onSubmit={handleSubmit(onEditSubmit)}>
                  <Col md="5">
                    <FormGroup>
                      <label className="form-label">Process Name</label>
                      <RSelect
                        options={processOptions}
                        value={processOptions.filter(({ value }) => value === formData.processName)[0]}
                        onChange={(e) => setFormData({ ...formData, processName: e.value })}
                      />
                    </FormGroup>
                  </Col>
                  <Col md="5">
                    <FormGroup>
                      <label className="form-label">Stage</label>
                      <RSelect
                        isMulti
                        closeMenuOnSelect={false}
                        options={stageOptions}
                        placeholder="Please select Stages"
                        onChange={(e) => setSelectedProcessStages(e)}
                        value={selectedProcessStages}
                      />
                    </FormGroup>
                  </Col>
                  <Col md="2">
                    <FormGroup>
                      <label className="form-label">Create Stage</label>
                      <Button color="primary" onClick={() => setModal({ ...modal, addStage: true })}>
                        <Icon name="plus" />
                      </Button>
                    </FormGroup>
                  </Col>
                  <Col md="12">
                    <FormGroup>
                      <label className="form-label">Status</label>
                      <RSelect
                        options={statusOptions}
                        value={statusOptions.filter(({ value }) => value === formData.status)}
                        placeholder="Select Status"
                        onChange={(e) => setFormData({ ...formData, status: e.value })}
                      />
                    </FormGroup>
                  </Col>

                  <Col size="12">
                    <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                      <li>
                        <li>
                          {isLoadBtn ? (
                            <Button color="primary" disabled>
                              <Spinner size="sm">Loading...</Spinner>
                              <span> Loading</span>
                            </Button>
                          ) : (
                            <Button color="primary" size="md" type="submit">
                              Update
                            </Button>
                          )}
                        </li>
                      </li>
                      <li>
                        <Button
                          onClick={(ev) => {
                            ev.preventDefault();
                            onFormCancel();
                          }}
                          className="link link-light"
                        >
                          Cancel
                        </Button>
                      </li>
                    </ul>
                  </Col>
                </Form>
              </div>
            </div>
          </ModalBody>
        </Modal>

        <Modal
          isOpen={modal.addStage}
          toggle={() => setModal({ ...modal, addStage: false })}
          className="modal-dialog-centered"
          size="lg"
        >
          <ModalBody>
            <a
              href="#cancel"
              onClick={(ev) => {
                ev.preventDefault();
                resetStageForm();
                setModal({ ...modal, addStage: false });
              }}
              className="close"
            >
              <Icon name="cross-sm" />
            </a>
            <div className="p-2">
              <h5 className="title">Add Process Stage</h5>
              <div className="mt-4">
                <Form className="row gy-4">
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Stage name</label>
                      <input
                        type="text"
                        name="stageName"
                        // defaultValue={formData.reason}
                        placeholder="Stage name"
                        onChange={(e) => setProcessStageData({ ...processStageData, stageName: e.target.value })}
                        className="form-control"
                        ref={register({
                          required: "This field is required",
                        })}
                      />
                      {errors.stageName && <span className="invalid">{errors.stageName.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Status</label>
                      <RSelect
                        options={statusOptions}
                        onChange={(e) => setProcessStageData({ ...processStageData, status: e.value })}
                      />
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Role</label>
                      <RSelect
                        options={roleOptions}
                        placeholder="Select Role"
                        onChange={(e) => setProcessStageData({ ...processStageData, role: e.value })}
                      />
                    </FormGroup>
                  </Col>

                  <Col size="12">
                    <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                      <li>
                        <Button
                          onClick={(e) => {
                            e.preventDefault();
                            onStageFormSubmit();
                          }}
                          color="primary"
                          size="md"
                          type="submit"
                        >
                          Submit
                        </Button>
                      </li>
                      <li>
                        <Button
                          onClick={(ev) => {
                            ev.preventDefault();
                            resetStageForm();
                            setModal({ ...modal, addStage: false });
                          }}
                          className="link link-light"
                        >
                          Cancel
                        </Button>
                      </li>
                    </ul>
                  </Col>
                </Form>
              </div>
            </div>
          </ModalBody>
        </Modal>

        <Modal isOpen={modal.view} toggle={() => setModal({ view: false })} className="modal-dialog-centered" size="lg">
          <ModalBody>
            <a
              href="#cancel"
              onClick={(ev) => {
                ev.preventDefault();
                onFormCancel();
              }}
              className="close"
            >
              <Icon name="cross-sm" />
            </a>
            <div className="p-2">
              <h5 className="title">Process Flow Details</h5>
              {details ? (
                <>
                  <div className="mt-4">
                    <div className="d-flex justify-content-between align-items-center my-2">
                      <Col md="6">
                        <p className="p-0 m-0">
                          <span className="font-weight-bold">Process Name: </span>
                          <span>{details?.processName}</span>
                        </p>
                      </Col>
                      <Col md="6">
                        <div className="p-0 m-0 w-100">
                          <span className="font-weight-bold">Stages: </span>
                          <div className="w-100 d-flex align-items-center justify-between bg-gray p-2 text-white">
                            <p className="p-0 m-0">Stage</p>
                            <p className="p-0 m-0">Role</p>
                          </div>
                          <div className="mt-2">
                            {details?.stage?.map((stg) => (
                              <div className="w-100 d-flex my-1 align-items-center justify-between">
                                <p className="m-0 p-0">{stg?.stage?.stageName}</p>
                                <p className="m-0 p-0">{stg?.stage?.role?.name}</p>
                              </div>
                            ))}
                          </div>
                        </div>
                      </Col>
                    </div>
                  </div>
                </>
              ) : null}
            </div>
          </ModalBody>
        </Modal>
      </Content>
    </React.Fragment>
  );
};
